module.exports = __webpack_public_path__ + "img/office_3.092e3a37.gif";